import { Controller } from "@hotwired/stimulus"

// Fires a toast and closes a modal when connected.
// Used by turbo_stream responses where inline scripts don't execute.
// Append to #toast-container so Stimulus connects reliably.
export default class extends Controller {
  static values = {
    message: String,
    type: { type: String, default: "info" },
    modalId: String
  }

  connect() {
    const message = this.messageValue
    const type = this.typeValue
    const modalId = this.modalIdValue

    if (modalId) {
      document.getElementById(modalId)?.close()
    }
    if (message && window.toast) {
      window.toast(message, { type })
    }

    requestAnimationFrame(() => this.element.remove())
  }
}
